var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenNoteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "white",
    stroke: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6353 9.24083C17.9475 8.91972 18.4537 8.91972 18.7659 9.24083C19.078 9.56193 19.078 10.0825 18.7659 10.4036L11.3801 18L10.8149 17.4106C10.7046 17.2956 10.5111 17.0941 10.262 16.8349C9.84686 16.4031 9.43095 15.9713 9.04175 15.5683L9.02245 15.5484C8.22598 14.7239 7.34175 13.8208 7.35803 13.8319C6.98995 13.5812 6.88922 13.071 7.13305 12.6924C7.37687 12.3138 7.87292 12.2102 8.241 12.461C8.37827 12.5545 8.81933 13.005 10.1566 14.3893L10.176 14.4094C10.5626 14.8096 10.9753 15.2381 11.3875 15.6668L17.6353 9.24083Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNoteCheck);
export default __webpack_public_path__ + "static/media/open-note-check.369bd4fe3e006d295118c07f2c429101.svg";
export { ForwardRef as ReactComponent };